<div class="cookie-banner" *ngIf="isVisible" role="alert">
  <div class="cookie-banner__content">
    <span nz-icon nzType="cookie" class="cookie-banner__icon"></span>
    <p class="cookie-banner__text">
      {{ "This site uses cookies to store data. By continuing to use the site, you consent to the use of these files" | translate }}
    </p>
  </div>
  <button type="button" class="cookie-banner__button" (click)="accept()">
    {{ "Accept and close" | translate }}
  </button>
</div>
